module.exports = __webpack_public_path__ + "static/media/img_21.1f7a3ede.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/gallery/img_21.jpg
// module id = 540
// module chunks = 0